<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner></mat-spinner>
</div>
<div class="row">
  <button class="btnBack" (click)="backBtn()" type="button">
    <span class="back-arrow">←</span>
    <span class="back-text">Back</span>
  </button>
   <a [routerLink]="['/member-details']" class="memDash" [queryParams]="{ id:memberId,isList:1}" style="margin-left: 80%;">
   Member Details</a>
</div>
<div class="row mt-3">
  <div class="col-12">
    <app-member-info [memberbasic]="memberList" [vital]="vitalDetails" [conditions]="glucoseDetails?.conditions || []" [deviceInfo]="deviceInfo" [planStatus]="planStatus" (onDatePicked)="extractData($event)"></app-member-info>
  </div>
</div>

<div class="row mt-4">
  <div class="col-12">
    <div class="main-tabs-container">
      <div class="main-tabs">
        <button type="button" class="tab-button" [class.active]="selectedMainTab === 'scores'" (click)="onMainTabSelect('scores')">Scores Summary</button>
        <button type="button" class="tab-button" [class.active]="selectedMainTab === 'glucose'" (click)="onMainTabSelect('glucose')">Glucose Mapping</button>
        <button type="button" class="tab-button" [class.active]="selectedMainTab === 'vitals'" (click)="onMainTabSelect('vitals')">Health Vitals</button>
        <button type="button" class="tab-button" [class.active]="selectedMainTab === 'lifestyle'" (click)="onMainTabSelect('lifestyle')">Lifestyle Habits</button>
        <button type="button" class="tab-button" [class.active]="selectedMainTab === 'mindpillar'" (click)="onMainTabSelect('mindpillar')">Mind Pillar</button>
        <button type="button" class="tab-button" [class.active]="selectedMainTab === 'bloodreporthistory'" (click)="onMainTabSelect('bloodreporthistory')">Blood report history</button>
      </div>
      <!-- <div class="global-date-picker">
        <mat-form-field>
          <mat-label>Dashboard date range</mat-label>
          <mat-date-range-input [rangePicker]="globalPicker">
            <input matStartDate placeholder="Start date" [(ngModel)]="globalStartDate" #globalStart>
            <input matEndDate placeholder="End date" [(ngModel)]="globalEndDate" #globalEnd (dateChange)="onGlobalDateRangeChange(globalStart, globalEnd)">
          </mat-date-range-input>
          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="globalPicker"></mat-datepicker-toggle>
          <mat-date-range-picker #globalPicker></mat-date-range-picker>
        </mat-form-field>
      </div> -->
    </div>
  </div>
</div>

<div class="member-dashboard-tab-content">
<ng-container *ngIf="selectedMainTab === 'scores'">
  <app-score [member]="memberList" [scores]="scores"></app-score>

<!-- Health Tools Section moved to Member Details -->
<!--
<div class="health-tools-section mt-4" *ngIf="memberList && memberList.firstName">
  <h2 class="health-tools-title">Health Tools</h2>
  <div class="health-tools-grid">
    <div class="health-tool-card">
       <div class="tool-icon blood-report-icon">
         <img src="assets/img/Blood report extraction.png" alt="Blood Report Icon" />
       </div>
       <div class="tool-content">
         <h3 class="tool-title blood-report-title">Blood Report Analyzer</h3>
         <p class="tool-description">Easily interpret lab values and identify key health markers.</p>
         <button class="tool-button" (click)="openBloodReportTool()">Open</button>
       </div>
     </div>
     <div class="health-tool-card">
       <div class="tool-icon glucose-data-icon">
         <img src="assets/img/Glucose Data Extraction.png" alt="Glucose Data Icon" />
       </div>
       <div class="tool-content">
        <h3 class="tool-title glucose-data-title">Upload CGM Graphs</h3>
         <p class="tool-description">Seamlessly extract and organize glucose readings for deeper insights.</p>
         <button class="tool-button" (click)="openGlucoseDataTool()">Open</button>
       </div>
     </div>
     <div class="health-tool-card">
       <div class="tool-icon biweekly-report-icon">
         <img src="assets/img/BiweeklyReport.png" alt="Biweekly Report Icon" />
       </div>
       <div class="tool-content">
         <h3 class="tool-title biweekly-report-title">Biweekly Report</h3>
         <p class="tool-description">Track health trends with automated biweekly summaries.</p>
         <button class="tool-button" (click)="openBiweeklyReportTool()">Open</button>
       </div>
     </div>
  </div>
</div>
-->

<!-- Recent Lab Reports Section - Commented out -->
<!-- <div class="row mt-4">
  <div class="labReport">Recent Lab Reports</div>
</div>

<app-lab-reports [reports]="labList"></app-lab-reports> -->

  <!-- <div class="row mt-5">
    <div class="labReport">Scores Summary</div>
  </div> -->
<div class="row">
  <div class="col-12 mt-3 d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
    <div style="flex: 0 0 auto;">
      <mat-form-field>
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="pickerScore">
          <input matStartDate placeholder="Start date" [(ngModel)]="previousDateScore" #dateRangeStartScore>
          <input matEndDate placeholder="End date" [(ngModel)]="currentDateScore" #dateRangeEndScore
            (dateChange)="filterByDateScore(dateRangeStartScore, dateRangeEndScore)">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="pickerScore"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerScore></mat-date-range-picker>
      </mat-form-field>
    </div>
    
    <!-- Time Period Buttons -->
    <div class="time-period-buttons" style="margin-left: auto;">
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonScore !== '1week'}" (click)="setTimePeriodScore('1week')">Last Week</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonScore !== '2weeks'}" (click)="setTimePeriodScore('2weeks')">Last Two Weeks</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonScore !== '1month'}" (click)="setTimePeriodScore('1month')">Last Month</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonScore !== '3months'}" (click)="setTimePeriodScore('3months')">Last Three Months</button>
    </div>
  </div>
</div>

<div class="row mt-1">
  <app-score-chart [memberbasic]="memberList" [sDate]="startDateScore" [eDate]="endDateScore" style="width:100%"></app-score-chart>
</div>

</ng-container>

<ng-container *ngIf="selectedMainTab === 'glucose'">
<!-- <div class="row mt-5">
  <div class="labReport">Glucose Mapping</div>
</div> -->
<div class="row">
  <div class="col-12 mt-3 d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
    <div style="flex: 0 0 auto;">
      <mat-form-field>
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" [(ngModel)]="previousDate" #dateRangeStart>
          <input matEndDate placeholder="End date" [(ngModel)]="currentDate" #dateRangeEnd (dateChange)="filterByDate(dateRangeStart, dateRangeEnd)">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    
    <!-- Time Period Buttons -->
    <div class="time-period-buttons" style="margin-left: auto;">
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonGlucose !== '1week'}" (click)="setTimePeriod('1week')">Last Week</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonGlucose !== '2weeks'}" (click)="setTimePeriod('2weeks')">Last Two Weeks</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonGlucose !== '1month'}" (click)="setTimePeriod('1month')">Last Month</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonGlucose !== '3months'}" (click)="setTimePeriod('3months')">Last Three Months</button>
    </div>
  </div>
</div>

<div class="row mt-3">
  <app-glucose [memberbasic]="memberList" [glucoseDetails]="glucoseDetails" [bmiData]="vitalDetails?.bmiData" [healthMetricsData]="glucoseHealthMetricsData" [startDate]="startDate" [endDate]="endDate" style="width:100%"></app-glucose>
</div>
<div class="row">
  <!--<div class="mt-3">
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="previousDate" #dateRangeStart>
        <input matEndDate placeholder="End date" [(ngModel)]="currentDate" #dateRangeEnd (dateChange)="filterByDate(dateRangeStart, dateRangeEnd)">
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>-->
</div>

<div class="row mt-3">
  <app-glucose-summary [glucoseSummary]="glucoseSummary"></app-glucose-summary>
</div>

</ng-container>

<!--
<div class="row mt-5">
  <div class="labReport">Insights</div>
</div>
<div class="row flex">
  <div class="col-12 text-right insight-arrow" *ngIf="this.glucoseDetails && this.glucoseDetails.insights && this.glucoseDetails.insights.length>0">
    <a class="btn arrow mb-3"
       href="#carouselExampleIndicators1"
       role="button"
       data-slide="next">
      <i class="fa fa-arrow-right"></i>
    </a> &nbsp;
    <a class="btn arrow mb-3 mr-1"
       href="#carouselExampleIndicators1"
       role="button"
       data-slide="prev">
      <i class="fa fa-arrow-left"></i>
    </a>

  </div>
  <div id="carouselExampleIndicators1" class="carousel slide"
       data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item" *ngFor='let insight of insights;let i=index;' [ngClass]="{'active': i <1}">
        <app-insights [insights]="insight" class="fullWidth"></app-insights>
      </div>
    </div>
  </div>
</div>
-->

<!--
<div class="row mt-5">
  <div class="labReport">Daily TimeLine</div>
</div>
<div class="row flex">
  <div class="col-12 text-right insight-arrow" *ngIf="this.glucoseDetails && this.glucoseDetails.timeLine && this.glucoseDetails.timeLine.length>0">
    <a class="btn arrow mb-3"
       href="#carouselExam"
       role="button"
       data-slide="next">
      <i class="fa fa-arrow-right"></i>
    </a> &nbsp;
    <a class="btn arrow mb-3 mr-1"
       href="#carouselExam"
       role="button"
       data-slide="prev">
      <i class="fa fa-arrow-left"></i>
    </a>

  </div>
  <div id="carouselExam" class="carousel slide"
       data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item" *ngFor='let timeLine of timeLines;let i=index;' [ngClass]="{'active': i <1}">
        <app-timelines [timeLines]="timeLine" class="fullWidth"></app-timelines>
      </div>
    </div>
  </div>
</div>
-->

<ng-container *ngIf="selectedMainTab === 'vitals'">
<!-- <div class="row mt-5">
  <div class="labReport">Health Vitals</div>
</div> -->
<div class="row">
  <div class="col-12 mt-3 d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
    <div style="flex: 0 0 auto;">
      <mat-form-field>
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="pickerBmi">
          <input matStartDate placeholder="Start date" [(ngModel)]="previousDateBmi" #dateRangeStartBmi>
          <input matEndDate placeholder="End date" [(ngModel)]="currentDateBmi" #dateRangeEndBmi
            (dateChange)="filterByDateBmi(dateRangeStartBmi, dateRangeEndBmi)">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="pickerBmi"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerBmi></mat-date-range-picker>
      </mat-form-field>
    </div>
    
    <!-- Time Period Buttons -->
    <div class="time-period-buttons" style="margin-left: auto;">
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonBmi !== '1week'}" (click)="setTimePeriodBmi('1week')">Last Week</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonBmi !== '2weeks'}" (click)="setTimePeriodBmi('2weeks')">Last Two Weeks</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonBmi !== '1month'}" (click)="setTimePeriodBmi('1month')">Last Month</button>
      <button type="button" class="btn" [ngClass]="{'inactive': activeButtonBmi !== '3months'}" (click)="setTimePeriodBmi('3months')">Last Three Months</button>
    </div>
  </div>
</div>

<div class="row mt-1">
  <app-bmi-chart [memberbasic]="memberList"  [sDate]="startDateBmi" [eDate]="endDateBmi" style="width:100%"></app-bmi-chart>
</div>

</ng-container>
 
<ng-container *ngIf="selectedMainTab === 'lifestyle'">
  <!-- <div class="row mt-4">
    <div class="labReport">Lifestyle Habits</div>
  </div> -->

  <div class="row mt-3">
    <div class="col-12">
      <div class="sub-tabs">
        <button type="button" class="tab-button" [class.active]="selectedLifestyleTab === 'nutrition'" (click)="onLifestyleTabSelect('nutrition')">Nutrition</button>
        <button type="button" class="tab-button" [class.active]="selectedLifestyleTab === 'sleep'" (click)="onLifestyleTabSelect('sleep')">Sleep</button>
  <button type="button" class="tab-button" [class.active]="selectedLifestyleTab === 'activity'" (click)="onLifestyleTabSelect('activity')">Activity</button>
  <button type="button" class="tab-button" [class.active]="selectedLifestyleTab === 'metrics'" (click)="onLifestyleTabSelect('metrics')">Metrics</button>
  <button type="button" class="tab-button" [class.active]="selectedLifestyleTab === 'waterlog'" (click)="onLifestyleTabSelect('waterlog')">Water Log</button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="selectedLifestyleTab === 'nutrition'">
    <!-- <div class="row mt-5">
      <div class="labReport">Nutrition</div>
    </div> -->
    <div class="row">
      <div class="col-12 mt-3 d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
        <div style="flex: 0 0 auto;">
          <mat-form-field>
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker3">
              <input matStartDate placeholder="Start date" [(ngModel)]="previousDateNU" #dateRangeStart3>
              <input matEndDate placeholder="End date" [(ngModel)]="currentDateNU" #dateRangeEnd3 (dateChange)="extractNutData(dateRangeStart3, dateRangeEnd3)">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-date-range-picker #picker3></mat-date-range-picker>
          </mat-form-field>
        </div>
        
        <!-- Time Period Buttons -->
        <div class="time-period-buttons" style="margin-left: auto;">
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonNutrition !== '1week'}" (click)="setTimePeriodNutrition('1week')">Last Week</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonNutrition !== '2weeks'}" (click)="setTimePeriodNutrition('2weeks')">Last Two Weeks</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonNutrition !== '1month'}" (click)="setTimePeriodNutrition('1month')">Last Month</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonNutrition !== '3months'}" (click)="setTimePeriodNutrition('3months')">Last Three Months</button>
        </div>
      </div>
    </div>

    <div class="row mt-1">
      <app-life-style
        [lifeStyle]="lifeStyle"
        [memberId]="memberId"
        [memberName]="memberList?.firstName + ' ' + memberList?.lastName"
        [nutritionStartDate]="nutritionStartDate"
        [nutritionEndDate]="nutritionEndDate"
        [selectedFoodLogId]="selectedFoodLogId"
        [selectedNutritionType]="selectedNutritionType"
        (refreshNutrition)="refreshNutritionData()"
        class="fullWidth">
      </app-life-style>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedLifestyleTab === 'sleep'">
    <!-- <div class="row mt-5">
      <div class="labReport">Sleep</div>
    </div> -->
    <div class="row">
      <div class="col-12 mt-3 d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
        <div style="flex: 0 0 auto;">
          <mat-form-field>
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="pickerSleep">
              <input matStartDate placeholder="Start date" [(ngModel)]="previousDateSleep" #dateRangeStartSleep>
              <input matEndDate placeholder="End date" [(ngModel)]="currentDateSleep" #dateRangeEndSleep
                (dateChange)="filterByDateSleep(dateRangeStartSleep, dateRangeEndSleep)">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerSleep"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerSleep></mat-date-range-picker>
          </mat-form-field>
        </div>
        
        <!-- Time Period Buttons -->
        <div class="time-period-buttons" style="margin-left: auto;">
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonSleep !== '1week'}" (click)="setTimePeriodSleep('1week')">Last Week</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonSleep !== '2weeks'}" (click)="setTimePeriodSleep('2weeks')">Last Two Weeks</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonSleep !== '1month'}" (click)="setTimePeriodSleep('1month')">Last Month</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonSleep !== '3months'}" (click)="setTimePeriodSleep('3months')">Last Three Months</button>
        </div>
      </div>
    </div>

    <div class="row mt-1">
      <app-sleep [sDate]="startDateSleep" [eDate]="endDateSleep" class="fullWidth"></app-sleep>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedLifestyleTab === 'activity'">
    <!-- <div class="row mt-5">
      <div class="labReport">Activity</div>
    </div> -->
    <div class="row">
      <div class="col-12 mt-3 d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
        <div style="flex: 0 0 auto;">
          <mat-form-field>
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="pickerActivity">
              <input matStartDate placeholder="Start date" [(ngModel)]="previousDateActivity" #dateRangeStartActivity>
              <input matEndDate placeholder="End date" [(ngModel)]="currentDateActivity" #dateRangeEndActivity
                (dateChange)="filterByDateActivity(dateRangeStartActivity, dateRangeEndActivity)">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerActivity"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerActivity></mat-date-range-picker>
          </mat-form-field>
        </div>
        
        <!-- Time Period Buttons -->
        <div class="time-period-buttons" style="margin-left: auto;">
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonActivity !== '1week'}" (click)="setTimePeriodActivity('1week')">Last Week</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonActivity !== '2weeks'}" (click)="setTimePeriodActivity('2weeks')">Last Two Weeks</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonActivity !== '1month'}" (click)="setTimePeriodActivity('1month')">Last Month</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonActivity !== '3months'}" (click)="setTimePeriodActivity('3months')">Last Three Months</button>
        </div>
      </div>
    </div>

    <div class="row mt-1">
      <app-activity [sDate]="startDateActivity" [eDate]="endDateActivity" class="fullWidth"></app-activity>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedLifestyleTab === 'metrics'">
    <div class="row">
      <div class="col-12 mt-3 d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
        <div style="flex: 0 0 auto;">
          <mat-form-field>
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="pickerMetrics">
              <input matStartDate placeholder="Start date" [(ngModel)]="previousDateMetrics" #dateRangeStartMetrics>
              <input matEndDate placeholder="End date" [(ngModel)]="currentDateMetrics" #dateRangeEndMetrics
                (dateChange)="filterByDateMetrics(dateRangeStartMetrics, dateRangeEndMetrics)">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerMetrics"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerMetrics></mat-date-range-picker>
          </mat-form-field>
        </div>
        
        <!-- Time Period Buttons -->
        <div class="time-period-buttons" style="margin-left: auto;">
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonMetrics !== '1week'}" (click)="setTimePeriodMetrics('1week')">Last Week</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonMetrics !== '2weeks'}" (click)="setTimePeriodMetrics('2weeks')">Last Two Weeks</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonMetrics !== '1month'}" (click)="setTimePeriodMetrics('1month')">Last Month</button>
          <button type="button" class="btn" [ngClass]="{'inactive': activeButtonMetrics !== '3months'}" (click)="setTimePeriodMetrics('3months')">Last Three Months</button>
        </div>
      </div>
    </div>

    <div class="row mt-1">
      <app-combined-metrics [sDate]="startDateMetrics" [eDate]="endDateMetrics" [memberId]="memberId" [memberbasic]="memberList" class="fullWidth"></app-combined-metrics>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedLifestyleTab === 'waterlog'">
    <div class="row mt-3">
      <app-water-log [memberId]="memberId" [hydrationGoalData]="hydrationGoalData" class="fullWidth"></app-water-log>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="selectedMainTab === 'mindpillar'">
  <div class="row mt-3">
    <div class="col-12">
      <div class="sub-tabs">
        <button type="button" class="tab-button" [class.active]="selectedMindPillarTab === 'quests'" (click)="onMindPillarTabSelect('quests')">Quests</button>
        <button type="button" class="tab-button" [class.active]="selectedMindPillarTab === 'moodcheckin'" (click)="onMindPillarTabSelect('moodcheckin')">Mood Checkin & Energy Levels</button>
        <button type="button" class="tab-button" [class.active]="selectedMindPillarTab === 'breathwork'" (click)="onMindPillarTabSelect('breathwork')">Breath work</button>
        <button type="button" class="tab-button" [class.active]="selectedMindPillarTab === 'mindfulness'" (click)="onMindPillarTabSelect('mindfulness')">Mindfulness Sessions</button>
        <button type="button" class="tab-button" [class.active]="selectedMindPillarTab === 'journal'" (click)="onMindPillarTabSelect('journal')">Journal </button>
        <button type="button" class="tab-button" [class.active]="selectedMindPillarTab === 'habits'" (click)="onMindPillarTabSelect('habits')">Habits</button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="selectedMindPillarTab === 'quests'">
    <app-quests [memberId]="memberId"></app-quests>
  </ng-container>

  <ng-container *ngIf="selectedMindPillarTab === 'moodcheckin'">
    <div class="row mt-3">
      <div class="col-12">
        <app-mood-checkin [memberId]="memberId"></app-mood-checkin>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedMindPillarTab === 'breathwork'">
    <div class="row mt-3">
      <div class="col-12">
        <app-breathwork [memberId]="memberId" [startDate]="startDateBreathwork" [endDate]="endDateBreathwork"></app-breathwork>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedMindPillarTab === 'mindfulness'">
    <app-mindfulness-sessions [memberId]="memberId" [startDate]="startDateMindfulness" [endDate]="endDateMindfulness"></app-mindfulness-sessions>
  </ng-container>

  <ng-container *ngIf="selectedMindPillarTab === 'journal'">
    <div class="row mt-3">
      <div class="col-12">
        <app-member-journal [memberId]="memberId"></app-member-journal>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedMindPillarTab === 'habits'">
    <div class="row mt-3">
      <div class="col-12">
        <app-habits [memberId]="memberId"></app-habits>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="selectedMainTab === 'bloodreporthistory'">
  <app-blood-report-history [memberId]="memberId" (loadingChange)="onBloodReportHistoryLoadingChanged($event)"></app-blood-report-history>
</ng-container>
</div>